import {
  ShoppingCart, Utensils, Home, Zap, Bus, Fuel, Plane, RefreshCw,
  Dumbbell, CreditCard, ShoppingBag, Film, HeartPulse, BookOpen,
  Circle, Briefcase, Laptop, TrendingUp, Gift, Wifi, Smartphone, Landmark,
} from "lucide-react";

// Maps every category (expense + income) to a lucide icon + a soft color pair.
export const CATEGORY_META = {
  // Expenses
  Groceries:       { Icon: ShoppingCart, fg: "text-lime-700",     bg: "bg-lime-50 dark:bg-lime-900/30" },
  Food:            { Icon: Utensils,     fg: "text-amber-700",    bg: "bg-amber-50 dark:bg-amber-900/30" },
  Rent:            { Icon: Home,         fg: "text-rose-700",     bg: "bg-rose-50 dark:bg-rose-900/30" },
  "Rent/Mortgage": { Icon: Home,         fg: "text-rose-700",     bg: "bg-rose-50 dark:bg-rose-900/30" },
  "Utility Bills": { Icon: Zap,          fg: "text-yellow-700",   bg: "bg-yellow-50 dark:bg-yellow-900/30" },
  Internet:        { Icon: Wifi,         fg: "text-blue-700",     bg: "bg-blue-50 dark:bg-blue-900/30" },
  "Phone Bill":    { Icon: Smartphone,   fg: "text-purple-700",   bg: "bg-purple-50 dark:bg-purple-900/30" },
  "Credit Cards":  { Icon: CreditCard,   fg: "text-red-700",      bg: "bg-red-50 dark:bg-red-900/30" },
  Loans:           { Icon: Landmark,     fg: "text-stone-700",    bg: "bg-stone-100 dark:bg-stone-800" },
  Transport:       { Icon: Bus,          fg: "text-sky-700",      bg: "bg-sky-50 dark:bg-sky-900/30" },
  Gas:             { Icon: Fuel,         fg: "text-orange-700",   bg: "bg-orange-50 dark:bg-orange-900/30" },
  Travel:          { Icon: Plane,        fg: "text-indigo-700",   bg: "bg-indigo-50 dark:bg-indigo-900/30" },
  Subscriptions:   { Icon: RefreshCw,    fg: "text-violet-700",   bg: "bg-violet-50 dark:bg-violet-900/30" },
  Fitness:         { Icon: Dumbbell,     fg: "text-emerald-700",  bg: "bg-emerald-50 dark:bg-emerald-900/30" },
  Payments:        { Icon: CreditCard,   fg: "text-slate-700",    bg: "bg-slate-100 dark:bg-slate-800" },
  Shopping:        { Icon: ShoppingBag,  fg: "text-pink-700",     bg: "bg-pink-50 dark:bg-pink-900/30" },
  Entertainment:   { Icon: Film,         fg: "text-fuchsia-700",  bg: "bg-fuchsia-50 dark:bg-fuchsia-900/30" },
  Health:          { Icon: HeartPulse,   fg: "text-red-700",      bg: "bg-red-50 dark:bg-red-900/30" },
  Education:       { Icon: BookOpen,     fg: "text-cyan-700",     bg: "bg-cyan-50 dark:bg-cyan-900/30" },

  // Income
  Salary:          { Icon: Briefcase,    fg: "text-emerald-700",  bg: "bg-emerald-50 dark:bg-emerald-900/30" },
  Freelance:       { Icon: Laptop,       fg: "text-teal-700",     bg: "bg-teal-50 dark:bg-teal-900/30" },
  Investment:      { Icon: TrendingUp,   fg: "text-green-700",    bg: "bg-green-50 dark:bg-green-900/30" },
  Gift:            { Icon: Gift,         fg: "text-pink-700",     bg: "bg-pink-50 dark:bg-pink-900/30" },

  Other:           { Icon: Circle,       fg: "text-slate-600",    bg: "bg-slate-100 dark:bg-slate-800" },
};

export const getCategoryMeta = (name) => CATEGORY_META[name] || CATEGORY_META.Other;
